<style lang="stylus">
    .OrgChartModal-mask
        modal-mask()
        .OrgChartModal-modal
            color $modal-content-textcolor
        .dialog-container-component
            .dialog-title
                .item-icon
                    left 14px
                .title-text
                    left 44px
        .OrgChartModal-container
            .OrgChartModal-body
                padding 0 16px 16px
                width 432px
                height 352px
                overflow auto
                border 1px solid var(--border-color-box-6)
                border-radius 6px
                >div
                    display inline-flex
                    align-items center
                    margin-top 15px
                    .ivu-checkbox
                        &:not(.ivu-checkbox-checked)
                            .ivu-checkbox-inner
                                background-color var(--bg-color-tertiary)
                    &:nth-of-type(odd)
                        width 68%
                    &:nth-of-type(even)
                        width 32%
            .custom
                background var(--theme-color-10)
                border-radius 6px
                padding 4px 12px
                margin 24px
                display inline-flex
                justify-content center
                align-items center
                cursor pointer
                svg
                    width 24px
                    height 24px
                    color var(--themeColor)
                .text
                    font-size 12px
                    line-height 20px
                    color var(--themeColor)
                    margin-left 8px
                &:hover,&:active
                    background var(--theme-color-20)
</style>

<template>
    <div class="OrgChartModal-mask">
        <Dialog
            class="OrgChartModal-modal"
            :title="$t('title')"
            :icon="EDCONFIG.IS_SDK ? '' : 'newEdrawIcon'"
            @ok="submitChange"
            @close="cancelChange"
            :showFooter="true"
        >
            <div class="OrgChartModal-container">
                <div class="OrgChartModal-body">
                    <div v-for="(item, index) in showData" :key="index">
                        <Checkbox v-model="item.check" :disabled="item.disable"></Checkbox>
                        <span>{{ item.name }}</span>
                    </div>
                </div>
                <div class="custom" @click="createProperty">
                    <iconSymbol :name="'card-edit'" />
                    <div class="text">{{ $t("editCardInfo") }}</div>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import FormatModal from "./FormatModal.vue";
    import FormulaModal from "./FormulaModal.vue";
    import Dialog from "./Dialog.vue";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            FormatModal,
            FormulaModal,
            Dialog,
        },
    })
    export default class OrgChartModal extends Vue {
        tempModalData: Array<object> = []; // 备份数据。取消后还原数据

        createProperty() {
            this.$store.commit("setDialogState", {
                type: "showShapeData",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }
        submitChange() {
            this.$store.commit("setOrgchartModal", { type: "all" });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        cancelChange() {
            this.$store.commit("setOrgchartModal", { type: "reset", data: this.tempModalData });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        get orgShapeCardData() {
            return this.$store.state.shape.orgShapeCardData;
        }
        set orgShapeCardData(v) {
            this.$store.commit("setShapeStatus", {
                type: "orgShapeCardData",
                data: v,
            });
        }
        get modalData() {
            return this.$store.state.orgchart.modalData;
        }
        set modalData(v) {
            this.$store.commit("setOrgchartModal", { type: "reset", data: v });
        }
        get canResetmodalData() {
            return this.$store.state.orgchart.canResetmodalData;
        }
        set canResetmodalData(v) {
            this.$store.commit("setOrgchartState", { type: "canResetmodalData", data: v });
        }
        get showShapeData() {
            return this.$store.state.dialog.showShapeData;
        }
        get showData() {
            if (this.showShapeData) {
                // 正在编辑卡片信息
                return;
            }
            if (this.canResetmodalData) {
                // 第一次进来，要先获取setOrgShapeCardData
                this.setOrgShapeCardData();
                this.canResetmodalData = false;
            } else {
                let modalData = JSON.parse(JSON.stringify(this.modalData)).slice(0, 50);
                let data = modalData.concat(this.orgShapeCardData);
                this.modalData = data;
                this.setOrgShapeCardData();
                if (!!this.tempModalData) {
                    this.tempModalData = this.modalData;
                }
            }

            return this.modalData;
        }

        get itemList() {
            // 卡片信息下拉列表
            return this.$store.state.orgchart.itemList;
        }

        setOrgShapeCardData() {
            // 50 是固定卡片列表长度
            let index = 0;
            let arr = this.modalData.slice(50);
            arr.forEach((item) => {
                if (!item.id) item.id = index++;
            });
            this.orgShapeCardData = arr;
        }

        //生命周期
        mounted() {}
        created() {}
        beforeDestroy() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "选择卡片信息",
    "checkbox": "勾选",
    "name": "名称",
    "type": "类型",
    "format": "格式",
    "formula": "公式",
    "more": "更多",
    "confirm": "确定",
    "cancel": "取消",
    "normal": "正常",
    "uppercase": "大写",
    "lowercase": "小写",
    "String": "字符",
    "Number": "数值",
    "Date": "日期时间",
    "Duration": "持续时间",
    "Currency": "货币",
    "Boolean": "布尔",
    "Percentage": "百分数",
    "Scientific": "科学计数",
    "Formula": "公式",
    "editCardInfo": "定义卡片信息"
  },
  "en": {
    "title": "Select Fields",
    "checkbox": "Checked",
    "name": "Name",
    "type": "Type",
    "format": "Format",
    "formula": "Formula",
    "more": "more",
    "confirm": "OK",
    "cancel": "Cancel",
    "normal": "Normal",
    "uppercase": "Uppercase",
    "lowercase": "Lowercase",
    "String": "String",
    "Number": "Number",
    "Date": "Date",
    "Duration": "Duration",
    "Currency": "Currency",
    "Boolean": "Boolean",
    "Percentage": "Percentage",
    "Scientific": "Scientific",
    "Formula": "Formula",
    "editCardInfo": "Define fields"
  },
  "fr": {
    "title": "Sélectionner les champs",
    "checkbox": "Choisissez",
    "name": "Nom",
    "type": "type",
    "format": "Format",
    "formula": "Formule mathématique",
    "more": "Plus d'options",
    "confirm": "Enregistrer",
    "cancel": "Annuler",
    "normal": "Ordinaire",
    "uppercase": "Capitaliser",
    "lowercase": "Minuscules",
    "String": "Caractères",
    "Number": "Valeur",
    "Date": "Date",
    "Duration": "Durée",
    "Currency": "Devise",
    "Boolean": "Booléen",
    "Percentage": "Pourcent",
    "Scientific": "Science",
    "Formula": "Formule mathématique",
    "editCardInfo": "Définir les champs"
  },
  "de": {
    "title": "Felder auswählen",
    "checkbox": "Auswählen",
    "name": "Name",
    "type": "Typ",
    "format": "Format",
    "formula": "Mathematische Formel",
    "more": "Mehr Optionen",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "normal": "Normal",
    "uppercase": "Groß schreiben",
    "lowercase": "Kleinschreiben",
    "String": "Zeichen",
    "Number": "Wert",
    "Date": "Datum",
    "Duration": "Dauerzeit",
    "Currency": "Währung",
    "Boolean": "Boolean",
    "Percentage": "Prozent",
    "Scientific": "Wissenschaft",
    "Formula": "Mathematische Formel",
    "editCardInfo": "Felder definieren"
  },
  "jp": {
    "title": "フィールドを選択",
    "checkbox": "チェックボックス",
    "name": "ファイル名",
    "type": "タイプ",
    "format": "書式",
    "formula": "公式",
    "more": "その他",
    "confirm": "OK",
    "cancel": "キャンセル",
    "normal": "標準",
    "uppercase": "大文字",
    "lowercase": "小文字",
    "String": "ストリング",
    "Number": "番号",
    "Date": "データ",
    "Duration": "期間",
    "Currency": "現在",
    "Boolean": "ブーリアン",
    "Percentage": "パーセンテージ",
    "Scientific": "科学的",
    "Formula": "フォーミュラ",
    "editCardInfo": "フィールドの定義"
  },
  "es": {
    "title": "Seleccionar Campos",
    "checkbox": "Comprobado",
    "name": "Nombre",
    "type": "Tipo",
    "format": "Formato",
    "formula": "Fórmula",
    "more": "más",
    "confirm": "Aceptar",
    "cancel": "Cancelar",
    "normal": "Normal",
    "uppercase": "Mayúscula",
    "lowercase": "Minúscula",
    "String": "Cuerda",
    "Number": "Número",
    "Date": "Fecha",
    "Duration": "Duration",
    "Currency": "Moneda",
    "Boolean": "Booleano",
    "Percentage": "Porcentaje",
    "Scientific": "Científico",
    "Formula": "Fórmula",
    "editCardInfo": "Definir campo"
  },
  "pt": {
    "title": "Selecionar Campos",
    "checkbox": "Verificado",
    "name": "Nome",
    "type": "Tipo",
    "format": "Formato",
    "formula": "Fórmula",
    "more": "mais",
    "confirm": "OK",
    "cancel": "Cancelar",
    "normal": "Normal",
    "uppercase": "Maiúsculas",
    "lowercase": "Minúsculas",
    "String": "Corda",
    "Number": "Número",
    "Date": "Data",
    "Duration": "Duração",
    "Currency": "Moeda",
    "Boolean": "Booleano",
    "Percentage": "Percentagem",
    "Scientific": "Científico",
    "Formula": "Fórmula",
    "editCardInfo": "Definir campos"
  },
  "it": {
    "title": "Seleziona Campi",
    "checkbox": "Spunta",
    "name": "Nome",
    "type": "Tipo",
    "format": "Formato",
    "formula": "Formula",
    "more": "Altro",
    "confirm": "OK",
    "cancel": "Annulla",
    "normal": "Normale",
    "uppercase": "Maiuscole",
    "lowercase": "Minuscole",
    "String": "Stringa",
    "Number": "Numeri",
    "Date": "Data",
    "Duration": "Durata",
    "Currency": "Valuta",
    "Boolean": "Boolean",
    "Percentage": "Percentuale",
    "Scientific": "Scientifico",
    "Formula": "Formula",
    "editCardInfo": "Definisci campi"
  },
  "tw": {
    "title": "選擇域",
    "checkbox": "勾選",
    "name": "名稱",
    "type": "類型",
    "format": "格式",
    "formula": "公式",
    "more": "更多",
    "confirm": "確定",
    "cancel": "取消",
    "normal": "正常",
    "uppercase": "大寫",
    "lowercase": "小寫",
    "String": "字符",
    "Number": "數值",
    "Date": "日期時間",
    "Duration": "持續時間",
    "Currency": "貨幣",
    "Boolean": "布爾",
    "Percentage": "百分數",
    "Scientific": "科學計數",
    "Formula": "公式",
    "editCardInfo": "定義域"
  },
  "kr": {
    "title": "필드 선택",
    "checkbox": "체크 ",
    "name": "이름",
    "type": "유형",
    "format": "형식 ",
    "formula": "공식",
    "more": "더보기",
    "confirm": "확인 ",
    "cancel": "취소 ",
    "normal": "정상",
    "uppercase": "대문자",
    "lowercase": "소문자",
    "String": "문자",
    "Number": "수치",
    "Date": "날짜 시간",
    "Duration": "지속시간",
    "Currency": "화폐",
    "Boolean": "부울",
    "Percentage": "퍼센트",
    "Scientific": "과학 계수",
    "Formula": "공식",
    "editCardInfo": "필드 정의"
  }
}
</i18n>
